import React from 'react';
import './MaintenanceBsm.css';


const Maintenance: React.FC = () => (
  <div className="Bsm-maintenance-container">
    <span className="Bsm-maintenance-icon" role="img" aria-label="maintenance">🚧</span>
    <div className="Bsm-maintenance-content">
      <h1 className="Bsm-maintenance-title">The site is currently under maintenance</h1>
      <p className="Bsm-maintenance-message">Please check back later.</p>
    </div>
  </div>
);

export default Maintenance;
